<template lang="pug">
#app
  lang-navigation-eng(v-if="$route.name == 'English'")
  lang-navigation-jp(v-else-if="$route.name == 'Japanese'")
  navigation(v-else, @footerProductClick="footerProductClick")
  #main(
    :class="[$route.name == 'English' || $route.name == 'Japanese' ? 'padding_top_lang' : 'padding_top_main']"
  )
    transition(name="page", mode="out-in")
      router-view(:freshFlag="freshFlag")
  cookie(v-if="isCookieDisplay", @agreeClick="agreeClick")
  quick-menu.d-none.d-md-block(
    v-if="$route.name != 'English' && $route.name != 'Japanese'"
  )
  transition(name="page", mode="out-in")
    quick-menu-mobile.d-md-none(
      v-if="isQuickMenuMobileShow && $route.name != 'English' && $route.name != 'Japanese'"
    )
</template>

<script>
import "@/assets/style/components.scss";
import "@/assets/style/main.scss";
import Navigation from "@/components/common/Navigation";
import LangNavigationEng from "@/components/eng/Navigation";
import LangNavigationJP from "@/components/jp/Navigation";
import Cookie from "@/components/common/Cookie";
import { getCookieAgree } from "@/utils/auth";
import QuickMenu from "@/components/common/QuickMenu";
import QuickMenuMobile from "@/components/common/QuickMenuMobile";

export default {
  name: "App",
  components: {
    navigation: Navigation,
    "lang-navigation-eng": LangNavigationEng,
    "lang-navigation-jp": LangNavigationJP,
    cookie: Cookie,
    "quick-menu": QuickMenu,
    "quick-menu-mobile": QuickMenuMobile,
  },
  data() {
    return {
      isCookieDisplay: true,
      isQuickMenuMobileShow: true,
      oldScrollTop: 0, //上一次滾動距離
      scrollTop: 0, //目前距離
      screenWidth: document.documentElement.clientWidth, //螢幕寬度
      freshFlag: 0,
      width: 0,
    };
  },
  created() {
    this.cookieAgree();
  },
  methods: {
    onResize() {
      var thiz = this;

      window.onresize = function () {
        // 定義視窗大小變更通知事件
        thiz.$store.state.screenWidth = document.documentElement.clientWidth; //視窗寬度
      };
    },
    handleScroll() {
      window.addEventListener("scroll", () => {
        if (this.width < 768) {
          this.scrollTop = window.pageYOffset;
        }
      });
    },
    agreeClick() {
      this.cookieAgree();
    },
    cookieAgree() {
      if (getCookieAgree()) {
        this.isCookieDisplay = false;
      } else {
        this.isCookieDisplay = true;
      }
    },
    footerProductClick() {
      this.freshFlag = this.freshFlag + 1;
    },
  },
  mounted() {
    this.onResize();
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll");
  },
  watch: {
    "$store.state.screenWidth": function (width) {
      //監聽螢幕寬度變化
      var oIframe = document.getElementById("app");
      oIframe.style.width = Number(width) + "px";
    },
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue == window.pageYOffset) {
          //滾動結束
          this.oldScrollTop = newValue; //每次滚动结束后都要给oldScrollTop赋值
          this.isQuickMenuMobileShow = true;
        }
      }, 100);
      if (this.oldScrollTop == oldValue) {
        //開始滾動
        this.isQuickMenuMobileShow = false;
      }
    },
  },
};
</script>

<style lang="scss">
.padding_top_main {
  padding-top: 90px;
}

.padding_top_lang {
  padding-top: 132px;
}

@media (max-width: 991px) {
  .padding_top_main {
    padding-top: 72px;
  }

  .padding_top_lang {
    padding-top: 76px;
  }
}

@media (max-width: 767px) {
  .padding_top_main {
    padding-top: 142px;
  }

  .padding_top_lang {
    padding-top: 72px;
  }
}

@media (max-width: 575px) {
  .padding_top_main {
    padding-top: 127px;
  }

  .padding_top_lang {
    padding-top: 57px;
  }
}
</style>
